import { img2, img3, img4, img5, img6, img7 } from "../../_components/Imagepath";

export default{

    Data:[
        {
          id: 1,
          key: 1,
          Purchase: "#25689825",
          DebitId: "#4987",
          Name: "John Smith",
          Img:img2,
          Phone:"+1 843-443-3282",
          Amount: "$1,54,220",
          Payment: "Cash",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Paid",
          Action: ""
        },
        {
          id: 2,
          key: 2,
          Purchase: "#25689826",
          DebitId: "#4988",
          Name: "Johnny",
          Img: img3,
          Phone: "+1 917-409-0861",
          Amount: "$2,54,220",
          Payment: "Cheque",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Pending",
          Action: ""
        },
        {
          id: 3,
          key: 3,
          Purchase: "#25689827",
          DebitId: "#4989",
          Name: "Robert",
          Img: img4,
          Phone: "+1 956-623-2880",
          Amount: "$1,84,220",
          Payment: "Cash",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Cancelled",
          Action: ""
        },
        {
          id: 4,
          key: 4,
          Purchase: "#25689828",
          DebitId: "#4990",
          Name: "Sharonda",
          Img: img5,
          Phone: "+1 707-439-1732",
          Amount: "$6,54,220",
          Payment: "Cheque",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Pending",
          Action: ""
        },
        {
          id: 5,
          key: 5,
          Purchase: "#25689829",
          DebitId: "#4991",
          Name: "Randall",
          Img: img7,
          Phone: "+1 559-741-9672",
          Amount: "$3,54,220",
          Payment: "Cash",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Paid",
          Action: ""
        },
        {
          id: 6,
          key: 6,
          Purchase: "#25689830",
          DebitId: "#4992",
          Name: "Pricilla",
          Img: img6,
          Phone: "+1 989-438-3131",
          Amount: "$1,54,220",
          Payment: "Cheque",
          date: "19 Dec 2022, 06:12 PM",
          Status: "Paid",
          Action: ""
        },
        {
            id: 7,
            key: 7,
            Purchase: "#25689825",
            DebitId: "#4987",
            Name: "John Smith",
            Img:img2,
            Phone:"+1 843-443-3282",
            Amount: "$1,54,220",
            Payment: "Cash",
            date: "19 Dec 2022, 06:12 PM",
            Status: "Paid",
            Action: ""
          },
          {
            id: 8,
            key: 8,
            Purchase: "#25689826",
            DebitId: "#4988",
            Name: "Johnny",
            Img: img3,
            Phone: "+1 917-409-0861",
            Amount: "$2,54,220",
            Payment: "Cheque",
            date: "19 Dec 2022, 06:12 PM",
            Status: "Pending",
            Action: ""
          },
          {
            id: 9,
            key: 9,
            Purchase: "#25689827",
            DebitId: "#4989",
            Name: "Robert",
            Img: img4,
            Phone: "+1 956-623-2880",
            Amount: "$1,84,220",
            Payment: "Cash",
            date: "19 Dec 2022, 06:12 PM",
            Status: "Cancelled",
            Action: ""
          }
    ]
}
